import {MutationTree} from "vuex";
import {OriginatorRulesState} from "@/store/rules/originator_rules/types";

export const mutations: MutationTree<OriginatorRulesState> = {
  setOriginatorRules: (state, payload) => {
    state.originatorRules = payload
  },
  pushOriginatorRules: (state, payload) => {
    state.originatorRules = state.originatorRules.concat(payload)
  },
  setOriginatorRuleItem: (state, payload) => {
    state.originatorRuleItem = payload
  }
}
